namespace Areas.Vendor {
    "use strict";

    //This is necessary to find the selected tab on loading
    // since the tabs object does not seem to have an items property
    var tabItems = [
        { id: 0, text: "Profile", url: "/Vendor/Profile/Index" },
        { id: 1, text: "Work Capabilities", url: "/Vendor/BidRange/Index" },
        { id: 2, text: "Owner", url: "/Vendor/Ownership/Index" },
        { id: 3, text: "Insurance", url: "/Vendor/Insurance/Index" },
        { id: 4, text: "License", url: "/Vendor/License/Index" },
        { id: 5, text: "Specialty", url: "/Vendor/Specialty/Index" },
        { id: 6, text: "Work Experience", url: "/Vendor/Experience/Index" },
        { id: 7, text: "Users", url: "/Vendor/User/Index" },
        { id: 8, text: "Attachments", url: "/Vendor/Attachments/Index" },
        { id: 9, text: "Events", url: "/Vendor/EventDetail/Index" }
    ];

    export function tabInitialized(params: any) {
        var tabs: DevExpress.ui.dxTabs = params.component;
        var currentPath = window.location.pathname;

        for (var i = 0; i < tabItems.length; i++) {
            if (currentPath.indexOf(tabItems[i].url) === 0) {
                tabs.option("selectedIndex", tabItems[i].id);
            }
        }
    }

    export function tabItemClick(params: any) {
        var tabs: DevExpress.ui.dxTabs = params.component;
        var url = params.itemData.url;
        window.location.href = url;

    }

}